import { computed, type ComputedRef } from 'vue'
import { operationPageConfigs, type OperationPageConfig } from '@/data/operationDesign'

function getRefreshButtonText(designKey: string) {
  if (designKey === 'refunds') return '刷新退款'
  if (designKey === 'verification') return '刷新核销'
  if (designKey === 'printers') return '刷新设备'
  if (designKey === 'messageLogs') return '刷新消息'
  if (designKey === 'messageTemplates') return '刷新模板'
  if (designKey === 'messageConfig') return '刷新配置'
  if (['dataOverview', 'dataOrders', 'dataProducts', 'storeRankPage'].includes(designKey)) return '刷新数据'
  if (['transactions', 'reconciliation', 'refundTransactions'].includes(designKey)) return '刷新财务'
  if (designKey === 'stores') return '刷新门店'
  if (designKey === 'productCategories') return '刷新分类'
  if (designKey === 'productCombos') return '刷新套餐'
  if (designKey === 'productExtras') return '刷新加料'
  if (designKey === 'inventory') return '刷新库存'
  if (designKey === 'products') return '刷新商品'
  if (['deliveryRules', 'deliveryMinAmount', 'deliveryAreas', 'deliveryPoints'].includes(designKey)) return '刷新配送'
  if (['droneDevices', 'droneTasks', 'droneFlights', 'droneFaults', 'droneMaintenances'].includes(designKey)) return '刷新无人机'
  if (['userManagement', 'userBalance', 'userPoints', 'userAssets'].includes(designKey)) return '刷新用户'
  if (['memberLevels', 'memberGrowth', 'memberPointsRules', 'memberBenefits'].includes(designKey)) return '刷新配置'
  if (designKey === 'systemAdmins') return '刷新管理员'
  if (designKey === 'roles') return '刷新角色'
  if (designKey === 'operationLogs') return '刷新日志'
  if (designKey === 'systemParams') return '刷新参数'
  if (designKey === 'paymentConfig') return '刷新支付配置'
  if (designKey === 'marketingCoupons') return '刷新优惠券'
  if (designKey === 'marketingCards') return '刷新卡券'
  if (designKey === 'marketingBanners') return '刷新 Banner'
  if (designKey === 'groupBuy') return '刷新拼团'
  if (designKey === 'marketingBargain') return '刷新砍价'
  if (designKey === 'marketingInvite') return '刷新邀请'
  if (designKey === 'flashSale') return '刷新秒杀'
  if (designKey === 'marketingRecharge') return '刷新套餐'
  return '刷新订单'
}

export function useOperationPageConfig(designKey: ComputedRef<string>, pageTitle: ComputedRef<string>) {
  const fallbackConfig = computed<OperationPageConfig>(() => ({
    title: pageTitle.value,
    cards: [{ title: pageTitle.value, status: '建设中', meta: ['设计壳已接入', '当前模块将沿用运营后台统一视觉、筛选栏、卡片和表格规范。'], footer: '等待业务接口接入' }],
  }))

  const config = computed(() => operationPageConfigs[designKey.value] ?? fallbackConfig.value)
  const refreshButtonText = computed(() => getRefreshButtonText(designKey.value))
  const isCreateAction = computed(() => {
    const action = config.value.action ?? ''
    return action.includes('新增') || action.includes('创建') || action.includes('新建')
  })

  return {
    config,
    refreshButtonText,
    isCreateAction,
  }
}
